import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ACCEPT_VERSION_HEADER,
  AuthHttpService,
} from '../auth-data/auth-http.service';
import { IResponseInfo } from '../http/http.data';
import { AccountMigration } from './models/account-migration.model';
import { Settings } from '../settings-data/settings.model';
import { serialize } from '../../utils/helpers/model.helper';
import { map } from 'rxjs/operators';

export const ACCOUNT_ACCEPT_VERSION = '3.0.0';

@Injectable()
export class OnboardingDataService {
  private _migrationUrl = '/as/migration';
  private _headers: any = {
    [ACCEPT_VERSION_HEADER]: ACCOUNT_ACCEPT_VERSION,
  };

  constructor(private _authHttpService: AuthHttpService) {}

  getAccountMigrationInfo(): Observable<AccountMigration> {
    return this._authHttpService
      .get(this._migrationUrl, null, this._headers)
      .pipe(
        map(
          ({ body, ..._ }: IResponseInfo) =>
            new AccountMigration(body.migration)
        )
      );
  }

  completeMigration(settings: Settings): Observable<Settings> {
    const body = {
      settings: serialize(settings).toJS(),
    };

    return this._authHttpService
      .post(this._migrationUrl, body, this._headers)
      .pipe(
        map(
          ({ body, ..._ }: IResponseInfo) =>
            new Settings(body['updated_settings'])
        )
      );
  }
}
